import React from 'react';
import "./project.css";
import project1 from './project1.png'
import project2 from './project2.png'
import project3 from './project3.png'
import project5 from './project5.png'
import project6 from './project6.png'
var data = [
  {
    id: 1,
    image: project1,
    title: "Urban Company",
    description: "Urban Company is Asia's largest online home services platform. Urban Company has also numerous international offices.",
    tech: " HTML, CSS, JavaScript",
    github: "https://github.com/Halderpritam123/defiant-wash-9428/tree/main/Urban%20Company%20Project",
    demo: "https://linxcompany.netlify.app/"
  },
  {
    id: 2,
    image: project2,
    title: "Shopclues",
    description: "ShopClues is an Indian online marketplace. It representing one of the largest valuation meltdowns for an Indian-based startup",
    tech: " HTML, CSS, JavaScript",
    github: "https://github.com/Halderpritam123/ShopClue/tree/main/database",
    demo: "https://shopeasy56.netlify.app/"
  },
  {
    id: 3,
    image: project3,
    title: "Nykaa",
    description: "Nykaa is an Indian e-commerce company. It sells beauty, wellness and fashion products across websites, mobile apps and 100+ offline stores.",
    tech: " HTML, CSS, JavaScript, Chakra UI, React, Firebase",
    github: "https://github.com/Halderpritam123/tested-rail-9493/tree/main/rct-101-app",
    demo: "https://nykaaa402.netlify.app/"
  },
  {
    id: 4,
    image: "https://user-images.githubusercontent.com/115461550/229465563-d6f7f749-3070-4214-887d-f38f9bf949ac.png",
    title: "Make My Trip",
    description: "MakeMyTrip is an Indian online travel company. the company provides online travel services including airline tickets, domestic and international holiday packages, hotel reservations, rail, and bus tickets. MakeMyTrip has also numerous international offices.",
    tech: " HTML, CSS, JavaScript, Chakra UI, React, Redux, Firebase",
    github: "https://github.com/Aajad2002/tropical-action-4372",
    demo: "https://647c89961899ac2e3195a675--relaxed-fenglisu-ac9f5e.netlify.app/"
  },
  {
    id: 5,
    image: project5,
    title: "Cronometer",
    description: "Cronometer is a website and mobile application that offers personalized nutrition tracking and health management tools. It allows users to track their food intake, exercise, and various health metrics to maintain a healthy lifestyle.",
    tech: "Chakra UI, React, Redux, chatjs, jwt-authentication,node js,mongodb,express, mongoatlas",
    github: "https://github.com/Halderpritam123/CronoMeter-clone",
    demo: "https://calofit-tm.netlify.app/"
  },
  {
    id: 6,
    image: project6,
    title: "Homely Horizons",
    description: "Homely Horizons is a web app that allows you to find and book hotels online. You can browse through hundreds of hotels, compare prices and ratings.Homely Horizons also has a chatbot that can answer your questions and help you with your booking.",
    tech: "Angular,Python,Flask,Mongo DB,Generative AI",
    github: "https://github.com/Halderpritam123/Homestead-Horizon",
    demo: "https://kaleidoscopic-choux-c57581.netlify.app/home"
  }
]

data=data.reverse()

const Project = () => {
  return (
    <section className='nav-link projects' id="projects">
      <h2>Projects</h2>
        <div className='container portfolio_container'>
          {data.map(({ id, image, title, description, tech, github, demo }) => {
            return (
              <article key={id} className='portfolio_item project-card'>
                <div className='portfolio_item-image'>
                  <img src={image} alt={title} />
                </div>
                <h3 className="project-title">{title}</h3>
                <p className="project-description">{description}</p>
                <br />
                <p className="project-tech-stack">Tech Used:{tech}</p>
                <br />
                <div className="portfolio_item-cta">
                  <div className='project-github-link'>
                    <a href={github} className='btn project-github-link' target='_blank' style={{color:"white",backgroundColor:"#2d3748"}}>Github</a>
                  </div>
                  <div className='project-deployed-link' >
                    <a href={demo} className='btn btn-primary' target='_blank' style={{backgroundColor:"#2d3748"}}>Live Demo</a>
                  </div>
                </div>
              </article>
            )
          })}

        </div>
    </section>
  );
}

export default Project;
